import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import "./App.css";
import MainLayOut from "./component/MainLayOut";
import Home from "./pages/Home";
import HomeAbout from "./pages/about/HomeAbout";
import BoardofDirectors from "./pages/about/BoardofDirectors";
import CEO from "./pages/about/CEO";
import CeoDesk from "./component/About/CeoDesk";
import Management from "./component/About/Management";
import AboutUs from "./component/About/AboutUs";
import OurSolutions from "./component/Solutions/OurSolutions";
import Career from "./component/Career/Career";
import ContactUs from "./pages/about/Contactus";
import Gallery from "./pages/about/Gallery";
import Awards from "./pages/about/Awards";
import { useEffect } from "react";
import BookMeeting from "./component/contact/BookMeeting";
import WhyUS from "./pages/about/WhyUS";
import PrivacyPolicy from './component/PrivacyPolicy/PrivacyPolicy';
import TermsAndConditions from './component/TermsAndConditions/TermsAndConditions';
// 🔹 A wrapper to handle scroll on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, [pathname]);

  return null;
}

function App() {
  return (
    <BrowserRouter>
      {/* this will run on every route change */}
      <ScrollToTop />

      <Routes>
        <Route path="/" element={<MainLayOut />}>
          <Route index element={<Home />} />
          <Route path="about" element={<HomeAbout />} />
          <Route path="ceo" element={<CEO />} />
          <Route path="contact-us" element={<ContactUs />} />
          <Route path="aboutus" element={<AboutUs />} />
          <Route path="ceodesk" element={<CeoDesk />} />
          <Route path="management" element={<Management />} />
          <Route path="oursolutions" element={<OurSolutions />} />
          <Route path="oursolutions/:solutionId" element={<OurSolutions />} />
          <Route path="career" element={<Career />} />
          <Route path="contact" element={<ContactUs />} />
          <Route path="gallery" element={<Gallery />} />
          <Route path="award" element={<Awards />} />
          <Route path="bookmeeting" element={<BookMeeting />} />
          <Route path="whycoempt" element={<WhyUS />} />
          <Route path="privacypolicy" element={<PrivacyPolicy />} />
          <Route path="termsandconditions" element={<TermsAndConditions />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
